<template>
  <div class="corpo">
        <rubricas-header />
        <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
                <rubricas-pesquisa />
            </div>
            <div class="col-md-1"></div>
        </div>
        <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10"></div>
            <div class="col-md-1"></div>
        </div>
    </div>
</template>

<script>
import header from '../shared/header';
import pesquisa from '../components/prazoEnvioPesquisa.vue';
export default {
  components:{
          'rubricas-header': header,
          'rubricas-pesquisa': pesquisa
        }
}
</script>
<style scoped>
    .corpo{
        overflow: hidden;
        min-height: 100vh;
    }
</style>



// WEBPACK FOOTER //
// src/screens/home.vue